export default {
      id: "vegetables-usage",
      viewBox: "0 0 43 36",
      url: __webpack_public_path__ + "img/icons.svg#vegetables",
      toString: function () {
        return this.url;
      }
    }